import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractStepDTO } from '@tj/tj-dmp-lib-api';
import { ON_CANCEL_TOKEN, ON_SAVE_TOKEN, PARTNER_TOKEN, READ_ONLY_MODE_TOKEN, STEP_TOKEN, TENANT_TOKEN } from '../injection-tokens';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'dmp-abstract-step-config',
    templateUrl: './abstract-step-config.component.html',
    styleUrls: ['./abstract-step-config.component.html'],
    standalone: false
})
export abstract class AbstractStepConfigComponent implements OnInit, OnDestroy {
  protected step: AbstractStepDTO;
  protected tenant?: string;
  protected partner?: string;
  protected readonly readOnlyMode: boolean;
  protected hasUnsavedChanges = false;
  protected destroy$ = new Subject<void>();
  protected isInitializing = false;

  private onSaveCallback: () => void;
  private onCancelCallback: () => void;

  constructor(
    @Inject(STEP_TOKEN) step: AbstractStepDTO,
    @Inject(TENANT_TOKEN) tenant: string,
    @Inject(PARTNER_TOKEN) partner: string,
    @Inject(READ_ONLY_MODE_TOKEN) readOnlyMode,
    @Inject(ON_SAVE_TOKEN) onSaveCallback: () => void,
    @Inject(ON_CANCEL_TOKEN) onCancelCallback: () => void,
  ) {
    this.step = step;
    this.tenant = tenant;
    this.partner = partner;
    this.readOnlyMode = readOnlyMode
    this.onSaveCallback = onSaveCallback;
    this.onCancelCallback = onCancelCallback;
  }

  ngOnInit(): void {
    if (this.step && this.tenant) {
      this.initializeComponent();
    } else {
      console.error('Step ou tenant manquant lors de l\'initialisation');
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Méthode abstraite
  protected abstract initializeComponent(): void;
  protected abstract updateStepFromForm(): void;
  protected abstract isConfigurationValid(): boolean;

  protected createFormControl(initialValue: any, validators?: any[]): FormControl {
    if (this.readOnlyMode) {
      return new FormControl({ value: initialValue, disabled: true });
    }
    return new FormControl(initialValue, validators);
  }

  protected replaceFormControl(form: FormGroup, controlName: string, newValue: any): void {
    form.setControl(controlName, this.createFormControl(newValue));
  }

  save(): void {
    if (!this.isConfigurationValid()) {
      this.showValidationErrors();
      return;
    }

    this.updateStepFromForm();
    this.step.complete = true;
    this.onSaveCallback();
    this.hasUnsavedChanges = false;
  }

  cancel(): void {
    this.onCancelCallback();
  }

  protected markAsChanged(): void {
    this.hasUnsavedChanges = true;
  }

  private showValidationErrors(): void {
    console.warn('Configuration invalide');
  }

}
